import dayjs from 'dayjs'
import { useCallback, useEffect, useRef, useState } from 'react'

import { PlayerColor } from 'features/board/board'
import { oppositePlayer } from 'features/board/utils'
import { finishGameByTimeout } from 'features/firebase/game-operations'
import { Game } from 'features/firebase/types'

import { getGameClock, isGameOpen } from './utils'

export const useGameClock = (game: Game, turn: PlayerColor) => {
  const prevTurn = useRef<PlayerColor>('white')
  const [startTime, setStartTime] = useState(dayjs())
  const [turnDuration, setTurnDuration] = useState(0)
  const clock = getGameClock(game.events, game.timeToPlay)
  const remainingTimeRef = useRef(clock[turn] - turnDuration)

  const resetTurn = useCallback(() => {
    setStartTime(dayjs())
    setTurnDuration(0)
  }, [])

  useEffect(() => {
    if (game.events.length === 1) {
      resetTurn()
    }
  }, [game.events, resetTurn])

  useEffect(() => {
    if (!isGameOpen(game.status)) return

    const timer = setInterval(() => {
      const newDuration = dayjs().diff(startTime, 'milliseconds')
      setTurnDuration(newDuration)
    }, 500)

    return () => clearInterval(timer)
  }, [startTime, game.status])

  useEffect(() => {
    if (turn !== prevTurn.current) {
      resetTurn()
    }

    prevTurn.current = turn
  }, [turn, resetTurn])

  useEffect(() => {
    remainingTimeRef.current = clock[turn] - turnDuration
  }, [clock, turnDuration, turn])

  useEffect(() => {
    if (!isGameOpen(game.status)) return

    const timer = setInterval(() => {
      if (remainingTimeRef.current < 0) {
        finishGameByTimeout(game.gameId, oppositePlayer(turn))
      }
    }, 1000)

    return () => clearInterval(timer)
  }, [game.status, game.gameId, turn])

  return { clock, turnDuration, resetTurn }
}
